import React, { useCallback, useEffect, useState, Fragment } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useTranslator } from '@jutro/locale';
import { publish } from '@jutro/events';
import { useAuth } from '@jutro/auth';
import { WMICButton } from 'wmic-components-platform-react';
import { WMICRichTextUtil, CONSTANTS, WMICTopics } from 'wmic-portals-utils-js';

import messages from './WMICLogoutConfirmationPage.messages';
import styles from './WMICLogoutConfirmationPage.module.scss';

const WMICLogoutConfirmationPage = ({ onLogin }) => {
    const translator = useTranslator();
    const history = useHistory();

    useEffect(() => {
        publish(WMICTopics.ROUTE_CHANGED, {
            channel: 'my account',
            flow: (window.wins_data_layer && window.wins_data_layer.flow) || '',
            page: 'my account:manage my account:logout confirmation',
            subchannel1: 'manage my account',
            sessionid: sessionStorage.getItem('X_GWRE_SESSION') || '',
            state: (window.wins_data_layer?.state || '').toString().toLowerCase()
        });
    }, []);
    const { login } = useAuth();

    const [logoutReason] = useState(() => localStorage.getItem('logout_reason'));

    useEffect(() => {
        localStorage.removeItem('logout_reason');
        localStorage.removeItem(CONSTANTS.AMP_LOCAL_STORAGE.USER_lOGGEDIN.NAME);
    }, []);

    const onButtonClick = useCallback(() => {
        sessionStorage.removeItem('gwAuthRecovery');
        if (onLogin) {
            onLogin();
            return;
        }
        try {
            login('', { prompt: 'login' });
        } catch (e) {
            // login() failed — user will need to retry
        }
    }, [login, onLogin]);
    
    return (
        <Fragment>
            <div className="ww-content-limit ww-page-header">
                <div className="ww-card--100w">
                    <h1>{translator(messages.logoutConfirmationPageTitle)}</h1>
                </div>
            </div>

            <div className="ww-content-limit ww-main-content" role="main">
                <div className={`${styles.wwCard66w} ww-card-vertical-root`}>
                    <div className="ww-card ww-card-footer">
                        <div className="ww-card__content">
                            <div>
                                {logoutReason === CONSTANTS.AMP_LOCAL_STORAGE.LOGOUT_REASON.LOGOUT && <p>{translator(messages.logoutConfirmationPageDescription)}</p>}
                                {logoutReason === CONSTANTS.AMP_LOCAL_STORAGE.LOGOUT_REASON.SESSION_MISMATCH && <p>{translator(messages.logoutConfirmationSessionMismatchDes)}</p>}
                                {logoutReason !== CONSTANTS.AMP_LOCAL_STORAGE.LOGOUT_REASON.LOGOUT && logoutReason !== CONSTANTS.AMP_LOCAL_STORAGE.LOGOUT_REASON.SESSION_MISMATCH && <p>{translator(messages.logoutConfirmationInactivityDes)}</p>}
                            </div>
                            <div>
                                <WMICButton type="primary" onClick={onButtonClick}>
                                    {translator(messages.logoutConfirmationPageButtonText)}
                                </WMICButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

WMICLogoutConfirmationPage.propTypes = {};

export default WMICLogoutConfirmationPage;